import * as Focus from '../common/focus';

window.addEventListener('load', function () {
  const toggleSearch = document.querySelector('.toggleSearch');
  const searchModal = document.querySelector('#search-modal');
  const dropdowns = document.querySelectorAll('.nav-primary .dropdown');

  function closeSearchModal() {
    searchModal.classList.remove('opened');
    toggleSearch.setAttribute('aria-expanded', 'false');

    if (searchModal.classList.contains('window')) {
      Focus.untrap_focus_inside(jQuery('#search-modal'));
      document.documentElement.classList.remove('lockedPosition');
    }
  }

  function openSearchModal() {
    const openEvent = new Event('opensearchmodal');
    searchModal.classList.add('opened');
    toggleSearch.setAttribute('aria-expanded', 'true');
    document.getElementById('search-field').focus();
    window.dispatchEvent(openEvent);

    if (searchModal.classList.contains('window')) {
      Focus.trap_focus_inside(jQuery('#search-modal'));
      document.documentElement.classList.add('lockedPosition');
    }
  }

  if (toggleSearch) {
    toggleSearch.addEventListener('click', function () {
      if (searchModal.classList.contains('opened')) {
        closeSearchModal();
      } else {
        openSearchModal();
      }
    });
  }

  // close search bar when dropdown opens from hover
  if (0 < dropdowns.length && !searchModal.classList.contains('window')) {
    dropdowns.forEach(function (dropdown) {
      dropdown.addEventListener('mouseover', function () {
        if (searchModal.classList.contains('opened')) {
          closeSearchModal();
        }
      });
    });
  }
});
